export const WEB_TRACER_VERSION = "1.0.0";

export const ROOT_SPAN_NAME = "View";

export const ONE_MINUTE_MS = 60000;

// Attribute flag used to mark spans that must be exported immediately
export const CRITICAL_SPAN_ATTRIBUTE = "span.critical";

export { version as PACKAGE_VERSION } from "../package.json";
